import { render } from "./FormatDate.vue?vue&type=template&id=72447582"
import script from "./FormatDate.vue?vue&type=script&lang=js"
export * from "./FormatDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__